import * as React from "react";
import Card from "react-bootstrap/Card";
import Image from "react-bootstrap/Image";
import Highlighter from "react-highlight-words";

import Reply from "./Reply";

const Comment = React.forwardRef(
  ({ data: { commentData, searchTerm }, style, index }, ref) => {
    const comment = commentData[index];
    const { totalReplyCount } = comment.snippet;
    const {
      publishedAt,
      authorProfileImageUrl,
      authorChannelUrl,
      authorDisplayName,
      textOriginal,
    } = comment.snippet.topLevelComment.snippet;
    const date = new Date(publishedAt).toLocaleString();
    return (
      <div ref={ref} style={{ ...style, overflow: "auto" }}>
        <Card>
          <Card.Body>
            <div>
              <span className="cr-count">
                Comment #: {commentData.length - index}
              </span>

              <div className="user-info">
                <Image
                  roundedCircle
                  className="img-user-avatar"
                  src={authorProfileImageUrl}
                  alt="..."
                />

                <div>
                  <Card.Title>
                    <a
                      href={authorChannelUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {authorDisplayName}
                    </a>
                  </Card.Title>

                  <p className="text-muted">
                    Date published:
                    {date}
                  </p>
                </div>
              </div>
            </div>

            <div>
              <Highlighter
                highlightClassName="highlight"
                searchWords={[searchTerm]}
                autoEscape
                textToHighlight={textOriginal}
              />
            </div>

            {totalReplyCount > 0 && <Reply comment={comment} />}
          </Card.Body>
        </Card>
      </div>
    );
  }
);

export default Comment;
